import InitialUSResponse from '../../JSON/initialScenarioUS.json';
import {
    Localization,
    Region,
    SegmentSelect,
    SelectionHeritage,
    SelectionAge,
    SelectionScenarioSex,
    SelectionCategory,
    Dma,
    SelectionHighlighted,
    SelectionPerAnnum,
} from 'utils';

export const createScenarioInitial: Record<any, any> = {
    [Localization.US]: {
        selectionData: {
            sex: `${SelectionScenarioSex.FEMALES},${SelectionScenarioSex.MALES}`,
            age_group: [
                { label: SelectionAge.GROUP_18_24, value: SelectionAge.GROUP_18_24 },
                { label: SelectionAge.GROUP_25_34, value: SelectionAge.GROUP_25_34 },
                { label: SelectionAge.GROUP_35_49, value: SelectionAge.GROUP_35_49 },
                { label: SelectionAge.GROUP_50_64, value: SelectionAge.GROUP_50_64 },
                { label: SelectionAge.GROUP_65_PLUS, value: SelectionAge.GROUP_65_PLUS },
            ],
            heritage: [
                { label: SelectionHeritage.WHITE, value: SelectionHeritage.WHITE },
                { label: SelectionHeritage.BLACK, value: SelectionHeritage.BLACK },
                { label: SelectionHeritage.ASIAN, value: SelectionHeritage.ASIAN },
                {
                    label: SelectionHeritage.HISPANIC_ANY_RACE,
                    value: SelectionHeritage.HISPANIC_ANY_RACE,
                },
                {
                    label: SelectionHeritage.MIXED_AND_OTHER_RACES,
                    value: SelectionHeritage.MIXED_AND_OTHER_RACES,
                },
            ],
            category: [
                {
                    label: SelectionCategory.CONSUMER_ELECTRONICS,
                    value: SelectionCategory.CONSUMER_ELECTRONICS,
                },
                { label: SelectionCategory.GROCERY, value: SelectionCategory.GROCERY },
                {
                    label: SelectionCategory.NON_ALCOHOLIC_BEVERAGES,
                    value: SelectionCategory.NON_ALCOHOLIC_BEVERAGES,
                },
                { label: SelectionCategory.INSURANCE, value: SelectionCategory.INSURANCE },
                {
                    label: SelectionCategory.ALCOGOLIC_BEVERAGES,
                    value: SelectionCategory.ALCOGOLIC_BEVERAGES,
                },
            ],
            demographic: 1,
        },
        plotlyInitial: {
            highlighted: SelectionHighlighted.TOTAL_DEFINED_SEGMENT,
            per_anum: SelectionPerAnnum.CUMULATIVE,
        },
        selectionState: {
            sex: `${SelectionScenarioSex.FEMALES},${SelectionScenarioSex.MALES}`,
            age_group: [
                SelectionAge.GROUP_18_24,
                SelectionAge.GROUP_25_34,
                SelectionAge.GROUP_35_49,
                SelectionAge.GROUP_50_64,
                SelectionAge.GROUP_65_PLUS,
            ],
            heritage: [
                SelectionHeritage.WHITE,
                SelectionHeritage.BLACK,
                SelectionHeritage.ASIAN,
                SelectionHeritage.HISPANIC_ANY_RACE,
                SelectionHeritage.MIXED_AND_OTHER_RACES,
            ],
            category: [SelectionCategory.GROCERY],
            demographic: 1,
            geoMapSelection: {
                Segment: SegmentSelect.REGION,
                REGION: [Region.WEST, Region.MIDWEST, Region.SOUTH, Region.NORTHEAST],
                DMA: Dma.NEW_YORK_NY,
            },
        },
        defaultSelectionState: {
            sex: `${SelectionScenarioSex.FEMALES},${SelectionScenarioSex.MALES}`,
            age_group: [
                SelectionAge.GROUP_18_24,
                SelectionAge.GROUP_25_34,
                SelectionAge.GROUP_35_49,
                SelectionAge.GROUP_50_64,
                SelectionAge.GROUP_65_PLUS,
            ],
            heritage: [
                SelectionHeritage.WHITE,
                SelectionHeritage.BLACK,
                SelectionHeritage.ASIAN,
                SelectionHeritage.HISPANIC_ANY_RACE,
                SelectionHeritage.MIXED_AND_OTHER_RACES,
            ],
            category: [SelectionCategory.GROCERY],
            demographic: 1,
            geoMapSelection: {
                Segment: SegmentSelect.REGION,
                REGION: [Region.WEST, Region.MIDWEST, Region.SOUTH, Region.NORTHEAST],
                DMA: Dma.NEW_YORK_NY,
            },
        },
        plotlySelection: {
            highlighted: SelectionHighlighted.TOTAL_DEFINED_SEGMENT,
            per_anum: SelectionPerAnnum.CUMULATIVE,
        },
        data: { ...InitialUSResponse },
        isDataLoading: false,
        dataLoaded: false,
    },
    [Localization.UK]: {
        selectionData: {
            sex: `${SelectionScenarioSex.FEMALES},${SelectionScenarioSex.MALES}`,
            age_group: [
                { label: SelectionAge.GROUP_18_24, value: SelectionAge.GROUP_18_24 },
                { label: SelectionAge.GROUP_25_34, value: SelectionAge.GROUP_25_34 },
                { label: SelectionAge.GROUP_35_49, value: SelectionAge.GROUP_35_49 },
                { label: SelectionAge.GROUP_50_64, value: SelectionAge.GROUP_50_64 },
                { label: SelectionAge.GROUP_65_PLUS, value: SelectionAge.GROUP_65_PLUS },
            ],
            heritage: [
                { label: SelectionHeritage.WHITE, value: SelectionHeritage.WHITE },
                { label: SelectionHeritage.BLACK, value: SelectionHeritage.BLACK },
                { label: SelectionHeritage.ASIAN, value: SelectionHeritage.ASIAN },
                {
                    label: SelectionHeritage.HISPANIC_ANY_RACE,
                    value: SelectionHeritage.HISPANIC_ANY_RACE,
                },
                {
                    label: SelectionHeritage.MIXED_AND_OTHER_RACES,
                    value: SelectionHeritage.MIXED_AND_OTHER_RACES,
                },
            ],
            category: [
                {
                    label: SelectionCategory.CONSUMER_ELECTRONICS,
                    value: SelectionCategory.CONSUMER_ELECTRONICS,
                },
                { label: SelectionCategory.GROCERY, value: SelectionCategory.GROCERY },
                {
                    label: SelectionCategory.NON_ALCOHOLIC_BEVERAGES,
                    value: SelectionCategory.NON_ALCOHOLIC_BEVERAGES,
                },
                { label: SelectionCategory.INSURANCE, value: SelectionCategory.INSURANCE },
                {
                    label: SelectionCategory.ALCOGOLIC_BEVERAGES,
                    value: SelectionCategory.ALCOGOLIC_BEVERAGES,
                },
            ],
            demographic: 1,
        },
        plotlyInitial: {
            highlighted: SelectionHighlighted.TOTAL_DEFINED_SEGMENT,
            per_anum: SelectionPerAnnum.CUMULATIVE,
        },
        selectionState: {
            sex: `${SelectionScenarioSex.FEMALES},${SelectionScenarioSex.MALES}`,
            age_group: [
                SelectionAge.GROUP_18_24,
                SelectionAge.GROUP_25_34,
                SelectionAge.GROUP_35_49,
                SelectionAge.GROUP_50_64,
                SelectionAge.GROUP_65_PLUS,
            ],
            heritage: [
                SelectionHeritage.WHITE,
                SelectionHeritage.BLACK,
                SelectionHeritage.ASIAN,
                SelectionHeritage.HISPANIC_ANY_RACE,
                SelectionHeritage.MIXED_AND_OTHER_RACES,
            ],
            category: [SelectionCategory.GROCERY],
            demographic: 1,
            geoMapSelection: {
                Segment: SegmentSelect.REGION,
                REGION: [Region.WEST, Region.MIDWEST, Region.SOUTH, Region.NORTHEAST],
                DMA: Dma.NEW_YORK_NY,
            },
        },
        defaultSelectionState: {
            sex: `${SelectionScenarioSex.FEMALES},${SelectionScenarioSex.MALES}`,
            age_group: [
                SelectionAge.GROUP_18_24,
                SelectionAge.GROUP_25_34,
                SelectionAge.GROUP_35_49,
                SelectionAge.GROUP_50_64,
                SelectionAge.GROUP_65_PLUS,
            ],
            heritage: [
                SelectionHeritage.WHITE,
                SelectionHeritage.BLACK,
                SelectionHeritage.ASIAN,
                SelectionHeritage.HISPANIC_ANY_RACE,
                SelectionHeritage.MIXED_AND_OTHER_RACES,
            ],
            category: [SelectionCategory.GROCERY],
            demographic: 1,
            geoMapSelection: {
                Segment: SegmentSelect.REGION,
                REGION: [Region.WEST, Region.MIDWEST, Region.SOUTH, Region.NORTHEAST],
                DMA: Dma.NEW_YORK_NY,
            },
        },
        plotlySelection: {
            highlighted: SelectionHighlighted.TOTAL_DEFINED_SEGMENT,
            per_anum: SelectionPerAnnum.CUMULATIVE,
        },
        data: { ...InitialUSResponse },
        isDataLoading: false,
        dataLoaded: false,
    },
};
